import { USER_CONFIRM_FETCH_REQUEST, USER_CONFIRM_FETCH_SUCCESS, USER_CONFIRM_FETCH_FAILURE } from './types';
import baseUrl from '../../url';

const normalizeHomepageVariant = (value) => {
    if (!value) return null;
    const v = String(value).trim();
    return (v === 'control' || v === 'ux') ? v : null;
}

const getHomepageVariant = () => {
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const params = Object.fromEntries(urlParams);

    const fromParams = params.hv || params.homepage_variant || params.homepageVariant;
    const normalizedParam = normalizeHomepageVariant(fromParams);
    if (normalizedParam) return normalizedParam;

    const cookieMatch = document?.cookie?.match(/(?:^|; )kadro_homepage_variant_raw=([^;]+)/);
    if (cookieMatch && cookieMatch[1]) {
        return normalizeHomepageVariant(decodeURIComponent(cookieMatch[1]));
    }

    return null;
}

const fetchUserConfirmRequest = () => {
    return {
        type: USER_CONFIRM_FETCH_REQUEST
    }
}

const fetchUserConfirmSuccess = data => {
    return {
        type: USER_CONFIRM_FETCH_SUCCESS,
        payload: data,
    }
}

const fetchUserConfirmFailure = error => {
    return {
        type: USER_CONFIRM_FETCH_FAILURE,
        payload: error,
    }
}

export const postConfirm = (phone, code, query) => {
        return (dispatch) => {
                // console.log("Confirm Action : ", query);
                dispatch(fetchUserConfirmRequest());
                const homepageVariant = getHomepageVariant();
                const params = new URLSearchParams(query || "");
                if (homepageVariant && !params.get('hv')) {
                    params.set('hv', homepageVariant);
                }
                const finalQuery = params.toString();

                fetch(`${baseUrl}/users/login/confirm${finalQuery !== "" ? `?${finalQuery}` : ``}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(homepageVariant ? { 'X-Homepage-Variant': homepageVariant } : {})
            },
            body: JSON.stringify({
                mobile: phone,
                code: code
            })
        })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchUserConfirmSuccess(response));
                if (response.token) {
                    localStorage.setItem("token", response.token);
                    let path = location.protocol + '//' + location.host
                    window.location.replace( path + `/book${window.location.search}`);
                } else {
                    localStorage.setItem("token", '');
                }
            })
            .catch((error) => {
                dispatch(fetchUserConfirmFailure(error.message));
            })
    }
}